import React , { Suspense, lazy } from "react";
import { SwmcFooter } from "footer-component";
import "./Footer.css";

const CustomFooter = () => {
 
  return (
    <div>
      <SwmcFooter type="swmc" showTacanewLogo={true} nydisclaimer={false} />

    </div>
  );
};

export default CustomFooter;